import { render, staticRenderFns } from "./PunkteSammeln.vue?vue&type=template&id=ecc6d2e6&"
import script from "./PunkteSammeln.vue?vue&type=script&lang=ts&"
export * from "./PunkteSammeln.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports